import React from "react";
import { withRouter } from "react-router-dom";

import FallbackUI from "../Layout/MainContent/FallbackUI/FallbackUI";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.log(error);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ maxWidth: "1272px", margin: "0 auto" }}>
          <FallbackUI />
        </div>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
